import React from 'react';
import ReactDOM from 'react-dom';

import Portal from 'react-portal';
import FullScreenOverlay from './FullScreenOverlay.js';

class Confirm extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <Portal closeOnEsc onClose={this.props.onClose} isOpened={(this.props.param !== false ? true:false)}>
			<FullScreenOverlay>
				<div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
					<h1>{this.props.title}</h1>
					<h2>{this.props.body}</h2>
					
					<div className="m-t-30">
						<button onClick={this.props.onClose} className="btn btn-lg btn-danger">
							<span><i style={{color:'#fff'}} className="icon wb-close"></i>{this.props.cancel ? this.props.cancel : 'Cancel'}</span>
						</button>&nbsp;&nbsp;&nbsp;
						<button onClick={(e) => {e.stopPropagation(); this.props.onAccept(this.props.param);}} className="btn btn-lg btn-dark">
							<span><i className="icon wb-check"></i>{this.props.accept ? this.props.accept : "Let's do it!"}</span>
						</button>
					</div>
				</div>
			</FullScreenOverlay>
		</Portal>
	}
}

export default Confirm;


// WEBPACK FOOTER //
// ./components/Confirm.js